import { stockQuantitiesChanged } from '../../../utils/stockQuantities';
import { MAX_INVENTORY_QUANTITY } from '../../../utils/inventoryInputs';
import React, { useEffect, useState, useRef } from 'react';
import { flushSync } from 'react-dom';
import { useHistory, useLocation } from 'react-router-dom';
import arrayMove from 'array-move';
import { toProductFilterParams } from './productListQuery';
import useAdminProductList from './useAdminProductList';
import axios from 'axios';
import Header from '../../Header';
import Footer from '../../Footer';
import { checkIsAdminLoggined } from '../../../utils/utils';
import { extractApiArray, getApiErrorText } from '../../../utils/apiResponse';
import { adminProductApi } from '../../../api/adminProductApi';
import {
  BulkArrivalDateModal,
  BulkClearArrivalModal,
  BulkDiscountModal,
  BulkDiscountCategoryModal,
  BulkStatusModal,
  BulkAddCategoryModal,
  BulkCreateProductsModal,
  BulkRemoveCategoryModal,
  DeleteProductConfirmModal,
  CurrencyRatesModal,
  StockHistoryModal
} from './modals';
import { fetchCurrencyRates, updateCurrencyRates } from '../../../api/settingsApi';
import ProductFilters from './ProductFilters';
import SelectedProductsDropdown from './SelectedProductsDropdown';
import ProductTable from './ProductTable';
import ProductEditModal from './ProductEditModal';
import Alert from '../../new/Alert';
import { PRODUCT_STATES, INITIAL_SELECTED_PRODUCT, DISCOUNT_CATEGORY_EMPTY } from './constants';
import { prepareImagesForUpload } from '../../../utils/imageUploadUtils';

const PRODUCT_MODAL_ID = '#productModal';
const CONFIRM_DELETE_MODAL_ID = '#confirmDeleteModal';

const AdminProductsPage = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    query: listQuery, products, loading: productsLoading, refreshing: productsRefreshing, error: productsError,
    totalCount, currentPage, pageCount, updateQuery: updateListQuery, refresh: refreshProducts
  } = useAdminProductList();
  const stateFilter = listQuery.state;
  const setStateFilter = value => updateListQuery({ state: value });
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const stateDropdownRef = useRef(null);
  const [showDiscountCategoryDropdown, setShowDiscountCategoryDropdown] = useState(false);
  const discountCategoryDropdownRef = useRef(null);
  const [innerProducts, setInnerProducts] = useState([]);
  const productPageMountedRef = useRef(true);
  const productEditSessionRef = useRef(0);
  const productSaveRef = useRef(false);
  const [productSaving, setProductSaving] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(INITIAL_SELECTED_PRODUCT);
  const [categories, setCategories] = useState([]);
  const [discountCategories, setDiscountCategories] = useState([]);
  const [alertType, setAlertType] = useState('');
  const [productErrorMessage, setProductErrorMessage] = useState('');
  const [inputRefs] = useState([]);
  const [deletedProduct, setDeletedProduct] = useState(null);
  const [deleteError, setDeleteError] = useState('');
  const [productWasDeleted, setProductWasDeleted] = useState(false);
  const [isInnerProductAdding, setIsInnerProductAdding] = useState(false);
  const [parseImageUrl, setParseImageUrl] = useState('');
  const [deliveredQuantity, setDeliveredQuantity] = useState('');
  const [purchasePrice, setPurchasePrice] = useState('');
  const [quantityUpdateAlert, setQuantityUpdateAlert] = useState('');
  const [productForArrival, setProductForArrival] = useState(null);
  const [showArrivalDropdown, setShowArrivalDropdown] = useState(false);
  const [arrivalDropdownPosition, setArrivalDropdownPosition] = useState({});
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [showSelectedDropdown, setShowSelectedDropdown] = useState(false);
  const [showBulkArrivalDateModal, setShowBulkArrivalDateModal] = useState(false);
  const [bulkArrivalDateValue, setBulkArrivalDateValue] = useState('');
  const [bulkUpdateLoading, setBulkUpdateLoading] = useState(false);
  const [bulkArrivalDateMessage, setBulkArrivalDateMessage] = useState(null);
  const [showBulkClearConfirmModal, setShowBulkClearConfirmModal] = useState(false);
  const [bulkClearConfirmMessage, setBulkClearConfirmMessage] = useState(null);
  const [bulkClearLoading, setBulkClearLoading] = useState(false);
  const [showBulkDiscountModal, setShowBulkDiscountModal] = useState(false);
  const [bulkDiscountValue, setBulkDiscountValue] = useState('');
  const [bulkDiscountMessage, setBulkDiscountMessage] = useState(null);
  const [showBulkCategoryModal, setShowBulkCategoryModal] = useState(false);
  const [bulkCategoryIds, setBulkCategoryIds] = useState([]);
  const [bulkCategorySearch, setBulkCategorySearch] = useState('');
  const [bulkCategoryMessage, setBulkCategoryMessage] = useState(null);
  const [showBulkRemoveCategoryModal, setShowBulkRemoveCategoryModal] = useState(false);
  const [bulkRemoveCategoryIds, setBulkRemoveCategoryIds] = useState([]);
  const [bulkRemoveCategorySearch, setBulkRemoveCategorySearch] = useState('');
  const [bulkRemoveCategoryMessage, setBulkRemoveCategoryMessage] = useState(null);
  const [showBulkStatusModal, setShowBulkStatusModal] = useState(false);
  const [bulkStatusValue, setBulkStatusValue] = useState('');
  const [bulkStatusMessage, setBulkStatusMessage] = useState(null);
  const [showBulkCreateModal, setShowBulkCreateModal] = useState(false);
  const [bulkCreateAlert, setBulkCreateAlert] = useState({ show: false, message: '' });
  const [showBulkDiscountCategoryModal, setShowBulkDiscountCategoryModal] = useState(false);
  const [bulkDiscountCategoryValue, setBulkDiscountCategoryValue] = useState('');
  const [bulkDiscountCategoryMessage, setBulkDiscountCategoryMessage] = useState(null);
  const [showCurrencyRatesModal, setShowCurrencyRatesModal] = useState(false);
  const [stockHistoryOpen, setStockHistoryOpen] = useState(false);
  const [stockHistoryProduct, setStockHistoryProduct] = useState({ id: null, name: '' });
  const [currencyRates, setCurrencyRates] = useState({ pound_rate: '', dollar_rate: '', euro_rate: '' });
  const [currencyRatesLoading, setCurrencyRatesLoading] = useState(false);
  const [showSelectAllDropdown, setShowSelectAllDropdown] = useState(false);
  const [selectAllIdsLoading, setSelectAllIdsLoading] = useState(false);
  const selectAllCheckboxRef = useRef(null);
  const selectAllDropdownRef = useRef(null);
  const arrivalSubmenuTimeoutRef = useRef(null);
  const categorySubmenuTimeoutRef = useRef(null);
  const [showArrivalSubmenu, setShowArrivalSubmenu] = useState(false);
  const [showCategorySubmenu, setShowCategorySubmenu] = useState(false);
  const productIdFilter = listQuery.productId;
  const setProductIdFilter = value => updateListQuery({ productId: value });
  const searchFilter = listQuery.search;
  const setSearchFilter = value => updateListQuery({ search: value });
  const categoryIdsFilter = listQuery.categoryIds;
  const setCategoryIdsFilter = value => updateListQuery({ categoryIds: value });
  const discountCategoryNamesFilter = listQuery.discountCategoryNames;
  const setDiscountCategoryNamesFilter = value => updateListQuery({ discountCategoryNames: value });
  const quantityFromFilter = listQuery.quantityFrom;
  const setQuantityFromFilter = value => updateListQuery({ quantityFrom: value });
  const quantityToFilter = listQuery.quantityTo;
  const setQuantityToFilter = value => updateListQuery({ quantityTo: value });
  const priceFromFilter = listQuery.priceFrom;
  const setPriceFromFilter = value => updateListQuery({ priceFrom: value });
  const priceToFilter = listQuery.priceTo;
  const setPriceToFilter = value => updateListQuery({ priceTo: value });
  const discountFromFilter = listQuery.discountFrom;
  const setDiscountFromFilter = value => updateListQuery({ discountFrom: value });
  const discountToFilter = listQuery.discountTo;
  const setDiscountToFilter = value => updateListQuery({ discountTo: value });
  const sortBy = listQuery.sortBy;
  const sortOrder = listQuery.sortOrder;
  const setSortBy = value => updateListQuery({ sortBy: value });
  const setSortOrder = value => updateListQuery({ sortOrder: value });

  const openStockHistoryForProduct = (product) => {
    if (!product || product.id == null || product.id === '') return;
    setStockHistoryProduct({ id: product.id, name: product.name || '' });
    setStockHistoryOpen(true);
  };

  const setRef = (ref) => {
    const indexOfRef = inputRefs.indexOf(ref);
    if (indexOfRef === -1 && ref !== null) {
      inputRefs.push(ref);
    }
  };

  const fetchDiscountCategories = () => {
    adminProductApi.getDiscountCategories().then(res => {
      if (!productPageMountedRef.current) return;
      setDiscountCategories(extractApiArray(res));
    }).catch(err => {
      if (!productPageMountedRef.current) return;
      console.error('Failed to fetch discount categories', err);
      setDiscountCategories([]);
    });
  };

  useEffect(() => {
    productPageMountedRef.current = true;
    checkIsAdminLoggined({ history });
    fetchCategories();
    fetchDiscountCategories();
    return () => {
      productPageMountedRef.current = false;
      productEditSessionRef.current += 1;
    };
  }, [history]);

  useEffect(() => {
    let active = true;
    const loadCurrencyRates = async () => {
      try {
        const data = await fetchCurrencyRates();
        if (!active) return;
        setCurrencyRates({ pound_rate: data.pound_rate || '', dollar_rate: data.dollar_rate || '', euro_rate: data.euro_rate || '' });
      } catch (err) {
        console.error('Failed to load currency rates', err);
      }
    };
    loadCurrencyRates();
    return () => { active = false; };
  }, [showCurrencyRatesModal]);

  useEffect(() => {
    const outside = event => {
      if (stateDropdownRef.current && !stateDropdownRef.current.contains(event.target)) setShowStateDropdown(false);
      if (discountCategoryDropdownRef.current && !discountCategoryDropdownRef.current.contains(event.target)) setShowDiscountCategoryDropdown(false);
    };
    if (showStateDropdown || showDiscountCategoryDropdown) document.addEventListener('mousedown', outside);
    return () => document.removeEventListener('mousedown', outside);
  }, [showStateDropdown, showDiscountCategoryDropdown]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showArrivalDropdown) {
        const insideTrigger = e.target.closest('.arrival-dropdown-container');
        const insideDropdownBox = e.target.closest('.position-fixed.bg-white.border');
        if (!insideTrigger && !insideDropdownBox) {
          setShowArrivalDropdown(false);
          setProductForArrival(null);
        }
      }
    };
    if (showArrivalDropdown) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showArrivalDropdown]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectAllDropdownRef.current && !selectAllDropdownRef.current.contains(e.target)) {
        setShowSelectAllDropdown(false);
      }
    };
    if (showSelectAllDropdown) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSelectAllDropdown]);

  const handleSearch = () => {
    if (currentPage === 0) refreshProducts();
    else updateListQuery({ page: 1 }, false);
  };

  const handleBulkCreated = (result) => {
    handleSearch();
    const created = result?.created ?? 0;
    const requested = result?.requested ?? 0;
    const errors = result?.errors || [];
    let message = `Створено: ${created} з ${requested}`;
    if (errors.length > 0) {
      message += ` (помилок: ${errors.length})`;
      const preview = errors.slice(0, 3).map(e => `${e.productCode || '—'}: ${e.reason}`).join('; ');
      if (preview) message += ` — ${preview}`;
    }
    setBulkCreateAlert({ show: true, message });
  };

  const handleResetFilters = () => history.push('/admin/products');

  const handlePageClick = ({ selected }) => updateListQuery({ page: selected + 1 }, false);

  const handleSort = (field) => updateListQuery({
    sortBy: field,
    sortOrder: sortBy === field ? (sortOrder === 'asc' ? 'desc' : 'asc') : (field === 'name' ? 'asc' : 'desc')
  });

  const hasActiveFilters = (productIdFilter !== '' && productIdFilter != null) || stateFilter.length > 0 ||
    categoryIdsFilter.length > 0 || (discountCategoryNamesFilter && discountCategoryNamesFilter.length > 0) || searchFilter || quantityFromFilter !== '' || quantityToFilter !== '' ||
    priceFromFilter !== '' || priceToFilter !== '' || discountFromFilter !== '' || discountToFilter !== '' || sortBy !== 'id' || sortOrder !== 'desc';


  const getStateFilterLabel = value => PRODUCT_STATES.find(item => item.value === value)?.label || value;
  const getCategoryFilterLabel = () => categoryIdsFilter.map(id => categories.find(category => category.id === id)?.name || `#${id}`).join(', ');
  const getDiscountCategoryFilterLabel = () => discountCategoryNamesFilter.map(name => name === DISCOUNT_CATEGORY_EMPTY ? 'Немає' : name).join(', ');

  const fetchInnerProducts = (productId) => {
    const session = productEditSessionRef.current;
    setInnerProducts([]);
    adminProductApi.getInnerProducts(productId).then(res => {
      if (!productPageMountedRef.current || session !== productEditSessionRef.current) return;
      setInnerProducts(res.data || []);
    }).catch(err => {
      if (!productPageMountedRef.current || session !== productEditSessionRef.current) return;
      console.error('Failed to fetch inner products', err);
      setInnerProducts([]);
    });
  };

  const fetchCategories = () => {
    adminProductApi.getCategories().then(res => {
      if (!productPageMountedRef.current) return;
      setCategories(res.data || []);
    }).catch(err => {
      if (!productPageMountedRef.current) return;
      console.error('Failed to fetch categories', err);
      setCategories([]);
    });
  };

  const handleClick = (categoryId) => {
    setSelectedProduct(previous => ({
      ...previous,
      categoryIds: previous.categoryIds.includes(categoryId)
        ? previous.categoryIds.filter(id => id !== categoryId)
        : [...previous.categoryIds, categoryId]
    }));
  };

  const addNewProduct = (e) => {
    e.preventDefault();
    setProductErrorMessage('');
    const state = selectedProduct.state && String(selectedProduct.state).trim();
    if (!state) {
      setProductErrorMessage('Потрібно заповнити поле статус');
      setAlertType('alert-danger');
      return;
    }
    if (productSaveRef.current) return;
    productSaveRef.current = true;
    setProductSaving(true);
    const editSession = productEditSessionRef.current;
    adminProductApi.createProduct(selectedProduct).then((res) => {
      refreshProducts();
      if (productEditSessionRef.current !== editSession) return;
      setSelectedProduct({ ...selectedProduct, id: res.data.productId, originalQuantity: selectedProduct.quantity, originalState: selectedProduct.state, quantityChangeReason: '' });
      setAlertType('success-add');
      setProductErrorMessage('');
    }).catch(err => {
      if (productEditSessionRef.current !== editSession) return;
      console.error('Create product failed', err);
      setAlertType('alert-danger');
      setProductErrorMessage(getApiErrorText(err, 'Помилка створення продукту'));
    }).finally(() => { productSaveRef.current = false; if (productPageMountedRef.current) setProductSaving(false); });
  };

  const updateProduct = (e) => {
    e.preventDefault();
    setProductErrorMessage('');
    const state = selectedProduct.state && String(selectedProduct.state).trim();
    if (!state) {
      setProductErrorMessage('Потрібно заповнити поле статус');
      setAlertType('alert-danger');
      return;
    }
    const quantity = Number(selectedProduct.quantity);
    if (selectedProduct.quantity == null || String(selectedProduct.quantity).trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0 || quantity > MAX_INVENTORY_QUANTITY) {
      setProductErrorMessage('Кількість має бути цілим невід’ємним числом');
      setAlertType('alert-danger');
      return;
    }
    const quantityChanged = stockQuantitiesChanged(selectedProduct);
    if (quantityChanged && !(selectedProduct.quantityChangeReason || '').trim()) {
      setProductErrorMessage('Вкажіть причину зміни кількості');
      setAlertType('alert-danger');
      return;
    }
    const payload = {
      ...selectedProduct,
      expectedArrivalDate: selectedProduct.expectedArrivalDate && String(selectedProduct.expectedArrivalDate).trim() !== ''
        ? (typeof selectedProduct.expectedArrivalDate === 'string' ? selectedProduct.expectedArrivalDate.split('T')[0] : selectedProduct.expectedArrivalDate)
        : null,
      images: selectedProduct.images.map(image => (typeof image === 'string' ? image : image.src))
    };
    if (productSaveRef.current) return;
    productSaveRef.current = true;
    setProductSaving(true);
    const editSession = productEditSessionRef.current;
    adminProductApi.updateProduct(payload).then(response => {
      refreshProducts();
      if (productEditSessionRef.current !== editSession) return;
      const savedQuantity = response?.data?.quantity ?? payload.quantity;
      setSelectedProduct(prev => ({
        ...prev,
        quantity: prev.quantity === payload.quantity ? savedQuantity : prev.quantity,
        originalQuantity: savedQuantity, originalState: payload.state,
        quantityChangeReason: prev.quantityChangeReason === payload.quantityChangeReason ? '' : prev.quantityChangeReason
      }));
      setAlertType('success-update');
      setProductErrorMessage('');
    }).catch(err => {
      if (productEditSessionRef.current !== editSession) return;
      console.error('Update product failed', err);
      setAlertType('alert-danger');
      setProductErrorMessage(getApiErrorText(err, 'Помилка оновлення продукту'));
    }).finally(() => { productSaveRef.current = false; if (productPageMountedRef.current) setProductSaving(false); });
  };

  const addQuantity = (productId, quantity, price, e) => {
    e.preventDefault();
    adminProductApi.addProductQuantity(productId, quantity, price)
      .then(() => {
        setProductForArrival(null);
        setShowArrivalDropdown(false);
        setPurchasePrice('');
        setDeliveredQuantity('');
        refreshProducts();
      })
      .catch(err => {
        console.error('Add quantity failed', err);
        alert(err.response?.data?.data || err.response?.data?.message || 'Помилка оновлення кількості');
      });
  };

  const handleOpenArrivalDropdown = (product, event) => {
    setProductForArrival(product);
    setDeliveredQuantity('');
    setPurchasePrice('');
    if (event?.currentTarget) {
      const buttonRect = event.currentTarget.getBoundingClientRect();
      setArrivalDropdownPosition({
        top: buttonRect.bottom + 5,
        right: window.innerWidth - buttonRect.right
      });
    }
    setShowArrivalDropdown(true);
  };

  const toggleProductSelection = (productId) => {
    setSelectedProductIds(prev =>
      prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
    );
  };

  const selectAllOnPage = () => {
    const idsOnPage = products.map(p => p.id);
    const allSelected = idsOnPage.length > 0 && idsOnPage.every(id => selectedProductIds.includes(id));
    setSelectedProductIds(prev =>
      allSelected ? prev.filter(id => !idsOnPage.includes(id)) : [...new Set([...prev, ...idsOnPage])]
    );
  };

  const clearSelection = () => {
    setSelectedProductIds([]);
    setShowSelectedDropdown(false);
  };

  const openBulkArrivalDateModal = () => {
    setShowSelectedDropdown(false);
    setBulkArrivalDateValue('');
    setBulkArrivalDateMessage(null);
    setShowBulkArrivalDateModal(true);
  };

  const applyBulkArrivalDate = () => {
    const dateStr = bulkArrivalDateValue && String(bulkArrivalDateValue).trim();
    if (!dateStr) return;
    setBulkUpdateLoading(true);
    setBulkArrivalDateMessage(null);
    adminProductApi.bulkUpdateProducts({
      productIds: selectedProductIds,
      expectedArrivalDate: dateStr
    }).then(() => {
      refreshProducts();
      setBulkArrivalDateMessage({ type: 'success', text: 'Дату надходження успішно оновлено.' });
    }).catch(err => {
      setBulkArrivalDateMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні.' });
    }).finally(() => setBulkUpdateLoading(false));
  };

  const openBulkClearConfirmModal = () => {
    setShowSelectedDropdown(false);
    setBulkClearConfirmMessage(null);
    setShowBulkClearConfirmModal(true);
  };

  const confirmBulkClearArrivalDate = () => {
    setBulkClearLoading(true);
    setBulkClearConfirmMessage(null);
    adminProductApi.bulkUpdateProducts({
      productIds: selectedProductIds,
      clearExpectedArrivalDate: true
    }).then(() => {
      setBulkArrivalDateValue('');
      refreshProducts();
      setBulkClearConfirmMessage('success');
    }).catch(err => {
      setBulkClearConfirmMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при очищенні.' });
    }).finally(() => setBulkClearLoading(false));
  };

  const saveCurrencyRates = async (poundRate, dollarRate, euroRate) => {
    setCurrencyRatesLoading(true);
    try {
      const data = await updateCurrencyRates(poundRate, dollarRate, euroRate);
      setCurrencyRates({ pound_rate: data.pound_rate || '', dollar_rate: data.dollar_rate || '', euro_rate: data.euro_rate || '' });
    } finally {
      setCurrencyRatesLoading(false);
    }
  };

  const openBulkDiscountModal = () => {
    setShowSelectedDropdown(false);
    setBulkDiscountValue('');
    setBulkDiscountMessage(null);
    setShowBulkDiscountModal(true);
  };

  const applyBulkDiscount = () => {
    const num = bulkDiscountValue.trim() === '' ? null : parseInt(bulkDiscountValue, 10);
    if (num === null || isNaN(num) || num < 0 || num > 100) {
      setBulkDiscountMessage({ type: 'error', text: 'Введіть число від 0 до 100.' });
      return;
    }
    setBulkUpdateLoading(true);
    setBulkDiscountMessage(null);
    adminProductApi.bulkUpdateProducts({ productIds: selectedProductIds, discount: num })
      .then(() => {
        refreshProducts();
        setBulkDiscountMessage({ type: 'success', text: 'Знижку успішно оновлено.' });
      }).catch(err => {
        setBulkDiscountMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні.' });
      }).finally(() => setBulkUpdateLoading(false));
  };

  const openBulkCategoryModal = () => {
    setShowSelectedDropdown(false);
    setBulkCategoryIds([]);
    setBulkCategorySearch('');
    setBulkCategoryMessage(null);
    setShowBulkCategoryModal(true);
  };

  const toggleBulkCategoryId = (categoryId) => {
    setBulkCategoryIds(prev =>
      prev.includes(categoryId) ? prev.filter(id => id !== categoryId) : [...prev, categoryId]
    );
  };

  const applyBulkCategory = () => {
    if (!bulkCategoryIds.length) {
      setBulkCategoryMessage({ type: 'error', text: 'Оберіть хоча б одну категорію.' });
      return;
    }
    setBulkUpdateLoading(true);
    setBulkCategoryMessage(null);
    adminProductApi.bulkUpdateProducts({ productIds: selectedProductIds, categoryIds: bulkCategoryIds })
      .then(() => {
        refreshProducts();
        setBulkCategoryMessage({ type: 'success', text: 'Категорії успішно додано.' });
      }).catch(err => {
        setBulkCategoryMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні.' });
      }).finally(() => setBulkUpdateLoading(false));
  };

  const openBulkRemoveCategoryModal = () => {
    setShowSelectedDropdown(false);
    setBulkRemoveCategoryIds([]);
    setBulkRemoveCategorySearch('');
    setBulkRemoveCategoryMessage(null);
    setShowBulkRemoveCategoryModal(true);
  };

  const toggleBulkRemoveCategoryId = (categoryId) => {
    setBulkRemoveCategoryIds(prev =>
      prev.includes(categoryId) ? prev.filter(id => id !== categoryId) : [...prev, categoryId]
    );
  };

  const applyBulkRemoveCategory = () => {
    if (!bulkRemoveCategoryIds.length) {
      setBulkRemoveCategoryMessage({ type: 'error', text: 'Оберіть хоча б одну категорію.' });
      return;
    }
    setBulkUpdateLoading(true);
    setBulkRemoveCategoryMessage(null);
    adminProductApi.bulkUpdateProducts({ productIds: selectedProductIds, removeCategoryIds: bulkRemoveCategoryIds })
      .then(() => {
        refreshProducts();
        setBulkRemoveCategoryMessage({ type: 'success', text: 'Категорії успішно видалено.' });
      }).catch(err => {
        setBulkRemoveCategoryMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при видаленні.' });
      }).finally(() => setBulkUpdateLoading(false));
  };

  const openBulkStatusModal = () => {
    setShowSelectedDropdown(false);
    setBulkStatusValue('ACTIVE');
    setBulkStatusMessage(null);
    setShowBulkStatusModal(true);
  };

  const openBulkDiscountCategoryModal = () => {
    setShowSelectedDropdown(false);
    setBulkDiscountCategoryValue('');
    setBulkDiscountCategoryMessage(null);
    setShowBulkDiscountCategoryModal(true);
  };

  const applyBulkDiscountCategory = () => {
    if (!bulkDiscountCategoryValue || bulkDiscountCategoryValue === '') {
      setBulkDiscountCategoryMessage({ type: 'error', text: 'Оберіть категорію знижки.' });
      return;
    }
    setBulkUpdateLoading(true);
    setBulkDiscountCategoryMessage(null);
    adminProductApi.bulkUpdateProducts({ productIds: selectedProductIds, discountCategoryName: bulkDiscountCategoryValue })
      .then(() => {
        refreshProducts();
        setBulkDiscountCategoryMessage({ type: 'success', text: 'Категорію знижки успішно оновлено.' });
      }).catch(err => {
        setBulkDiscountCategoryMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні.' });
      }).finally(() => setBulkUpdateLoading(false));
  };

  const applyBulkStatus = () => {
    if (!bulkStatusValue || bulkStatusValue === '') {
      setBulkStatusMessage({ type: 'error', text: 'Оберіть статус.' });
      return;
    }
    setBulkUpdateLoading(true);
    setBulkStatusMessage(null);
    adminProductApi.bulkUpdateProducts({ productIds: selectedProductIds, state: bulkStatusValue })
      .then(() => {
        refreshProducts();
        setBulkStatusMessage({ type: 'success', text: 'Статус успішно оновлено.' });
      }).catch(err => {
        setBulkStatusMessage({ type: 'error', text: err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні.' });
      }).finally(() => setBulkUpdateLoading(false));
  };

  const applyBulkClearArrivalDate = () => {
    setShowBulkArrivalDateModal(false);
    openBulkClearConfirmModal();
  };

  const selectAllMatchingFilters = () => {
    setSelectAllIdsLoading(true);
    const requestSearch = location.search;
    adminProductApi.getProductIds(toProductFilterParams(listQuery)).then(res => {
      if (!productPageMountedRef.current || history.location.search !== requestSearch) return;
      const ids = res.data.ids || [];
      setSelectedProductIds(ids);
      setShowSelectAllDropdown(false);
    }).catch(err => console.error('Failed to fetch product ids', err))
      .finally(() => { if (productPageMountedRef.current) setSelectAllIdsLoading(false); });
  };

  const isAllOnPageSelected = products.length > 0 && products.every(p => selectedProductIds.includes(p.id));
  const isSomeOnPageSelected = products.some(p => selectedProductIds.includes(p.id));

  useEffect(() => {
    const ref = selectAllCheckboxRef.current;
    if (!ref) return;
    ref.indeterminate = isSomeOnPageSelected && !isAllOnPageSelected;
  }, [isSomeOnPageSelected, isAllOnPageSelected]);

  const parseExpectedArrivalDate = (value) => {
    if (value == null || value === '') return '';
    if (typeof value === 'string') return value.split('T')[0];
    if (Array.isArray(value) && value.length >= 3) {
      const [y, m, d] = value;
      const month = (m != null && m < 10) ? '0' + m : String(m);
      const day = (d != null && d < 10) ? '0' + d : String(d);
      return `${y}-${month}-${day}`;
    }
    if (typeof value === 'object' && (value.year != null || value.monthValue != null || value.dayOfMonth != null)) {
      const y = value.year;
      const m = value.monthValue != null ? value.monthValue : (value.month != null ? value.month + 1 : 1);
      const d = value.dayOfMonth != null ? value.dayOfMonth : value.day;
      const ms = m < 10 ? '0' + m : String(m);
      const ds = d < 10 ? '0' + d : String(d);
      return `${y}-${ms}-${ds}`;
    }
    return '';
  };

  const nullableState = (parentId) => {
    productEditSessionRef.current += 1;
    setSelectedProduct({ ...INITIAL_SELECTED_PRODUCT, parentId });
    inputRefs.forEach(elem => { elem.checked = false; });
    setInnerProducts([]);
    setAlertType('');
    setIsInnerProductAdding(false);
    setParseImageUrl('');
    setQuantityUpdateAlert('');
  };

  const initializeProduct = (product) => {
    productEditSessionRef.current += 1;
    setAlertType('');
    setProductErrorMessage('');
    const categoryIds = (product.categories || []).map(category => category.id);
    const images = (product.images || []).map(image => ({
      src: image.imagePath || image.awsName || image.path || (typeof image === 'string' ? image : null),
      width: 1,
      height: 1
    }));
    inputRefs.forEach(elem => {
      const indexOfCategory = categoryIds.findIndex(catId => catId.toString() === elem.id);
      elem.checked = indexOfCategory !== -1;
    });
    const stateValue = product.state != null ? (typeof product.state === 'string' ? product.state : (product.state.databaseValue || product.state)) : '';
    const discountCategoryName = product.discountCategoryName != null && product.discountCategoryName !== '' ? product.discountCategoryName : '';
    setSelectedProduct({
      id: product.id,
      productCode: product.code != null ? product.code : product.productCode,
      barcode: product.barcode != null ? product.barcode : '',
      packBarcode: product.packBarcode ?? '',
      packQuantity: product.packQuantity ?? '',
      name: product.name,
      description: product.description,
      price: product.price,
      quantity: product.quantity ?? 0,
      originalQuantity: product.quantity ?? 0,
      quantityChangeReason: '',
      discount: product.discount,
      parentId: product.parentId,
      priceInPounds: product.priceInPounds != null && product.priceInPounds !== '' ? String(product.priceInPounds) : '',
      priceInUSD: product.priceInUSD != null && product.priceInUSD !== '' ? String(product.priceInUSD) : '',
      priceInEuro: product.priceInEuro != null && product.priceInEuro !== '' ? String(product.priceInEuro) : '',
      purchasePrice: product.purchasePrice,
      expectedArrivalDate: parseExpectedArrivalDate(product.expectedArrivalDate),
      manufacturerUrl: product.manufacturerUrl != null ? product.manufacturerUrl : '',
      state: stateValue,
      originalState: stateValue,
      discountCategoryName,
      categoryIds,
      images
    });
  };

  const editParentProduct = (product) => {
    initializeProduct(product);
    fetchInnerProducts(product.id);
  };

  const editInnerProduct = (innerProduct) => {
    initializeProduct(innerProduct);
  };

  const onChangeHandler = async (event) => {
    const data = new FormData();
    const preparedFiles = await prepareImagesForUpload(event.target.files, {
      onlyMobile: true,
      maxWidth: 1920,
      maxHeight: 1920,
      quality: 0.82,
      minBytes: 700 * 1024
    });
    for (let x = 0; x < preparedFiles.length; x++) {
      data.append('images', preparedFiles[x]);
    }
    adminProductApi.uploadProductImages(selectedProduct.id, data)
      .then(res => {
        const responseImages = res.data.data.uploadedImagesNames.map(path => ({ src: path, width: 1, height: 1 }));
        setSelectedProduct({ ...selectedProduct, images: selectedProduct.images.concat(responseImages) });
      });
    event.target.value = '';
  };

  const removeImage = (e, imagePath) => {
    e.preventDefault();
    adminProductApi.deleteProductImage(selectedProduct.id, imagePath)
      .then(() => {
        const imageIndex = selectedProduct.images.findIndex(image => image.src === imagePath);
        const newImages = [...selectedProduct.images];
        newImages.splice(imageIndex, 1);
        setSelectedProduct({ ...selectedProduct, images: newImages });
      });
  };

  const deleteProduct = (e) => {
    e.preventDefault();
    setDeleteError('');
    adminProductApi.deleteProduct(deletedProduct.id).then(() => {
      setProductWasDeleted(true);
      setDeleteError('');
      refreshProducts();
      if (deletedProduct.parentId !== null) fetchInnerProducts(deletedProduct.parentId);
      if (selectedProduct?.id === deletedProduct.id) {
        nullableState(null);
        setProductErrorMessage('');
        setAlertType('');
      }
    }).catch(err => {
      console.error('Delete product failed', err);
      setDeleteError(getApiErrorText(err, 'Помилка деактивації товару'));
    });
  };

  const returnToParent = (parentId) => {
    setIsInnerProductAdding(false);
    setAlertType('');
    const product = products.find(p => p.id === parentId);
    if (product) {
      initializeProduct(product);
      fetchInnerProducts(product.id);
    }
  };

  const handleParseImageUrlChange = (event) => {
    event.preventDefault();
    setParseImageUrl(event.target.value);
  };

  const callParseImagesApi = (event) => {
    event.preventDefault();
    adminProductApi.parseProductImages(selectedProduct.id, parseImageUrl)
      .then(res => {
        const responseImages = res.data.data.uploadedImagesNames.map(path => ({ src: path, width: 1, height: 1 }));
        setSelectedProduct({ ...selectedProduct, images: selectedProduct.images.concat(responseImages) });
      })
      .catch(error => console.error('Parse images error', error));
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setSelectedProduct({
      ...selectedProduct,
      images: arrayMove(selectedProduct.images, oldIndex, newIndex)
    });
  };

  const renderDeleteProductButton = () => {
    if (!deletedProduct) return null;
    if (!productWasDeleted) {
      return (
        <button type="button" className="btn btn-danger" onClick={e => deleteProduct(e)}>
          Деактивувати
        </button>
      );
    }
    return null;
  };

  return (
    <div className="container">
      <button id="back-to-top" type="button" className="btn btn-light btn-lg back-to-top" aria-label="На початок сторінки" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        <i className="bi bi-caret-up-square-fill" />
      </button>

      <div className="row">
        <div className="col p-0">
          <Header />
        </div>
      </div>

      <ProductFilters
        stateFilter={stateFilter}
        setStateFilter={setStateFilter}
        showStateDropdown={showStateDropdown}
        setShowStateDropdown={setShowStateDropdown}
        stateDropdownRef={stateDropdownRef}
        categoryIdsFilter={categoryIdsFilter}
        setCategoryIdsFilter={setCategoryIdsFilter}
        discountCategoryNamesFilter={discountCategoryNamesFilter}
        setDiscountCategoryNamesFilter={setDiscountCategoryNamesFilter}
        discountCategories={discountCategories}
        showDiscountCategoryDropdown={showDiscountCategoryDropdown}
        setShowDiscountCategoryDropdown={setShowDiscountCategoryDropdown}
        discountCategoryDropdownRef={discountCategoryDropdownRef}
        quantityFromFilter={quantityFromFilter}
        setQuantityFromFilter={setQuantityFromFilter}
        quantityToFilter={quantityToFilter}
        setQuantityToFilter={setQuantityToFilter}
        priceFromFilter={priceFromFilter}
        setPriceFromFilter={setPriceFromFilter}
        discountFromFilter={discountFromFilter}
        setDiscountFromFilter={setDiscountFromFilter}
        discountToFilter={discountToFilter}
        setDiscountToFilter={setDiscountToFilter}
        priceToFilter={priceToFilter}
        setPriceToFilter={setPriceToFilter}
        productIdFilter={productIdFilter}
        setProductIdFilter={setProductIdFilter}
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
        categories={categories}
        sortBy={sortBy}
        setSortBy={setSortBy}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        getStateFilterLabel={getStateFilterLabel}
        getCategoryFilterLabel={getCategoryFilterLabel}
        getDiscountCategoryFilterLabel={getDiscountCategoryFilterLabel}
        hasActiveFilters={hasActiveFilters}
        handleSearch={handleSearch}
        handleResetFilters={handleResetFilters}
        onAddProduct={() => flushSync(() => nullableState(null))}
        onOpenBulkCreate={() => setShowBulkCreateModal(true)}
        productModalId={PRODUCT_MODAL_ID}
        onOpenCurrencyRates={() => setShowCurrencyRatesModal(true)}
      />

      <div className="row mb-3" style={{ borderBottom: 'none', position: 'relative', minHeight: '32px' }}>
        <div className="col-12 p-0 d-flex align-items-center">
          <div style={{ minHeight: '32px' }}>
            <SelectedProductsDropdown
              selectedCount={selectedProductIds.length}
              show={showSelectedDropdown}
              onToggleShow={setShowSelectedDropdown}
              onCloseDropdown={() => setShowSelectedDropdown(false)}
              onOpenBulkArrivalDate={openBulkArrivalDateModal}
              onOpenBulkClearArrivalDate={openBulkClearConfirmModal}
              onOpenBulkAddCategory={openBulkCategoryModal}
              onOpenBulkRemoveCategory={openBulkRemoveCategoryModal}
              onOpenBulkDiscount={openBulkDiscountModal}
              onOpenBulkStatus={openBulkStatusModal}
              onOpenBulkDiscountCategory={openBulkDiscountCategoryModal}
              onClearSelection={clearSelection}
              bulkClearLoading={bulkClearLoading}
              arrivalSubmenuTimeoutRef={arrivalSubmenuTimeoutRef}
              categorySubmenuTimeoutRef={categorySubmenuTimeoutRef}
              showArrivalSubmenu={showArrivalSubmenu}
              setShowArrivalSubmenu={setShowArrivalSubmenu}
              showCategorySubmenu={showCategorySubmenu}
              setShowCategorySubmenu={setShowCategorySubmenu}
            />
          </div>
          <h5 className="font-weight-bold mb-0 position-absolute mb-0" style={{ left: '50%', transform: 'translateX(-50%)', border: 'none', borderBottom: 'none' }}>
            Всього товарів: {totalCount}
          </h5>
          {productsRefreshing && <span className='ml-auto small text-muted' role='status'>Оновлення…</span>}
        </div>
      </div>

      {productsError && <div role="alert" className="alert alert-danger">{productsError}</div>}
      {productsLoading && <div role="status" className="text-muted py-2">Завантаження товарів…</div>}
      <ProductTable
        products={products}
        selectedProductIds={selectedProductIds}
        toggleProductSelection={toggleProductSelection}
        selectAllOnPage={selectAllOnPage}
        selectAllMatchingFilters={selectAllMatchingFilters}
        isAllOnPageSelected={isAllOnPageSelected}
        isSomeOnPageSelected={isSomeOnPageSelected}
        selectAllCheckboxRef={selectAllCheckboxRef}
        selectAllDropdownRef={selectAllDropdownRef}
        showSelectAllDropdown={showSelectAllDropdown}
        setShowSelectAllDropdown={setShowSelectAllDropdown}
        selectAllIdsLoading={selectAllIdsLoading}
        totalCount={totalCount}
        sortBy={sortBy}
        sortOrder={sortOrder}
        handleSort={handleSort}
        handleOpenArrivalDropdown={handleOpenArrivalDropdown}
        showArrivalDropdown={showArrivalDropdown}
        productForArrival={productForArrival}
        arrivalDropdownPosition={arrivalDropdownPosition}
        deliveredQuantity={deliveredQuantity}
        setDeliveredQuantity={setDeliveredQuantity}
        purchasePrice={purchasePrice}
        setPurchasePrice={setPurchasePrice}
        addQuantity={addQuantity}
        onOpenStockHistory={openStockHistoryForProduct}
        onEditProduct={editParentProduct}
        onUpdateDiscount={(productId, discount) => {
          adminProductApi.bulkUpdateProducts({ productIds: [productId], discount }).then(() => {
            refreshProducts();
          }).catch(err => {
            console.error('Failed to update discount', err);
            alert(err.response?.data?.message || err.response?.data?.data || err.message || 'Помилка при оновленні знижки');
          });
        }}
        onDeleteProduct={(product) => {
          setDeletedProduct(product);
          setProductWasDeleted(false);
          setDeleteError('');
        }}
        productModalId={PRODUCT_MODAL_ID}
        confirmDeleteModalId={CONFIRM_DELETE_MODAL_ID}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={handlePageClick}
      />

      <ProductEditModal
        modalId={PRODUCT_MODAL_ID}
        selectedProduct={selectedProduct}
        saving={productSaving}
        setSelectedProduct={setSelectedProduct}
        categories={categories}
        discountCategories={discountCategories}
        innerProducts={innerProducts}
        isInnerProductAdding={isInnerProductAdding}
        alertType={alertType}
        alertMessage={productErrorMessage}
        quantityUpdateAlert={quantityUpdateAlert}
        parseImageUrl={parseImageUrl}
        inputRefs={inputRefs}
        setRef={setRef}
        handleClick={handleClick}
        onAddProduct={addNewProduct}
        onUpdateProduct={updateProduct}
        onClose={() => { nullableState(null); setProductErrorMessage(''); setAlertType(''); }}
        onUploadImages={onChangeHandler}
        removeImage={removeImage}
        onParseImageUrlChange={handleParseImageUrlChange}
        callParseImagesApi={callParseImagesApi}
        onSortEnd={onSortEnd}
        editInnerProduct={editInnerProduct}
        onDeleteInnerProduct={(innerProduct) => {
          setDeletedProduct(innerProduct);
          setProductWasDeleted(false);
          setDeleteError('');
        }}
        nullableState={nullableState}
        returnToParent={returnToParent}
        addInnerProduct={() => {
          nullableState(selectedProduct.id);
          setIsInnerProductAdding(true);
        }}
        currencyRates={currencyRates}
        onOpenStockHistory={openStockHistoryForProduct}
      />

      <StockHistoryModal
        show={stockHistoryOpen}
        productId={stockHistoryProduct.id}
        productName={stockHistoryProduct.name}
        onClose={() => setStockHistoryOpen(false)}
      />

      <CurrencyRatesModal
        show={showCurrencyRatesModal}
        onClose={() => !currencyRatesLoading && setShowCurrencyRatesModal(false)}
        poundRate={currencyRates.pound_rate}
        dollarRate={currencyRates.dollar_rate}
        euroRate={currencyRates.euro_rate}
        onSave={saveCurrencyRates}
        loading={currencyRatesLoading}
      />

      <BulkArrivalDateModal
        show={showBulkArrivalDateModal}
        onClose={() => !bulkUpdateLoading && setShowBulkArrivalDateModal(false)}
        value={bulkArrivalDateValue}
        onChange={setBulkArrivalDateValue}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkArrivalDate}
        onClearDate={applyBulkClearArrivalDate}
        loading={bulkUpdateLoading}
        message={bulkArrivalDateMessage}
      />

      <BulkClearArrivalModal
        show={showBulkClearConfirmModal}
        onClose={() => !bulkClearLoading && setShowBulkClearConfirmModal(false)}
        selectedCount={selectedProductIds.length}
        onConfirm={confirmBulkClearArrivalDate}
        loading={bulkClearLoading}
        confirmMessage={bulkClearConfirmMessage}
      />

      <BulkDiscountModal
        show={showBulkDiscountModal}
        onClose={() => !bulkUpdateLoading && setShowBulkDiscountModal(false)}
        value={bulkDiscountValue}
        onChange={setBulkDiscountValue}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkDiscount}
        loading={bulkUpdateLoading}
        message={bulkDiscountMessage}
      />

      <BulkDiscountCategoryModal
        show={showBulkDiscountCategoryModal}
        onClose={() => !bulkUpdateLoading && setShowBulkDiscountCategoryModal(false)}
        value={bulkDiscountCategoryValue}
        onChange={setBulkDiscountCategoryValue}
        discountCategories={discountCategories}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkDiscountCategory}
        loading={bulkUpdateLoading}
        message={bulkDiscountCategoryMessage}
      />

      <BulkStatusModal
        show={showBulkStatusModal}
        onClose={() => !bulkUpdateLoading && setShowBulkStatusModal(false)}
        value={bulkStatusValue}
        onChange={setBulkStatusValue}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkStatus}
        loading={bulkUpdateLoading}
        message={bulkStatusMessage}
      />

      <BulkAddCategoryModal
        show={showBulkCategoryModal}
        onClose={() => !bulkUpdateLoading && setShowBulkCategoryModal(false)}
        categoryIds={bulkCategoryIds}
        onToggleCategory={toggleBulkCategoryId}
        search={bulkCategorySearch}
        onSearchChange={setBulkCategorySearch}
        categories={categories}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkCategory}
        loading={bulkUpdateLoading}
        message={bulkCategoryMessage}
      />

      <BulkRemoveCategoryModal
        show={showBulkRemoveCategoryModal}
        onClose={() => !bulkUpdateLoading && setShowBulkRemoveCategoryModal(false)}
        categoryIds={bulkRemoveCategoryIds}
        onToggleCategory={toggleBulkRemoveCategoryId}
        search={bulkRemoveCategorySearch}
        onSearchChange={setBulkRemoveCategorySearch}
        categories={categories}
        selectedCount={selectedProductIds.length}
        onApply={applyBulkRemoveCategory}
        loading={bulkUpdateLoading}
        message={bulkRemoveCategoryMessage}
      />

      <BulkCreateProductsModal
        show={showBulkCreateModal}
        onClose={() => setShowBulkCreateModal(false)}
        categories={categories}
        onCreated={handleBulkCreated}
      />

      <Alert
        show={bulkCreateAlert.show}
        setShow={(show) => setBulkCreateAlert(prev => ({ ...prev, show }))}
        message={bulkCreateAlert.message}
        className="alert-success"
        timeout={4000}
      />

      <DeleteProductConfirmModal
        productWasDeleted={productWasDeleted}
        deleteError={deleteError}
        onClose={() => {
          setDeletedProduct(null);
          setDeleteError('');
          setProductWasDeleted(false);
        }}
        renderDeleteButton={renderDeleteProductButton}
      />

      <Footer />
    </div>
  );
};

export default AdminProductsPage;
